import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireComponent} from '../umpire-component';

export interface UmpireComponentText
  extends UmpireComponent<UmpireComponentTypeEnum.TEXT> {
  content: string;
}
